import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { ImageItem } from "@app/types";
import { useState } from "react";
import { IcRefresh, IcX } from "../icons";
import { CopyButton } from "../ui";
import { parseWan, wanPriceText } from "./wan.util";

function IPXoayModal({ portalDialogRef, portalData }: PortalDialogProps) {
  const image: ImageItem = portalData;

  // Chọn là thực hiện luôn, không hỏi lại bằng hộp xác nhận
  const handleClickStart = (wan: string) => {
    portalDialogRef.close({ wan });
  };

  const handleClickChangeIP = (wan: string) => {
    portalDialogRef.close({ wan, change_ip: true });
  };

  // Danh sách gói IP xoay và trạng thái mỗi gói: tính y như bản cũ
  const wans = (image?.ssh?.router_xoay?.split(",") || []).map((wan) => {
    const wanName = wan.split(" - ")[0].trim();
    const wan_selected = image?.ssh?.wan_selected;

    const is_started_by_any_one_not_me = wan_selected?.find(
      (value) => value.name === wanName && value?.account_id != image?.account?._id
    );

    const indexStartByMe = wan_selected?.findIndex(
      (value) => value.name === wanName && value?.account_id == image?.account?._id
    );

    const is_started_by_me = indexStartByMe !== undefined && indexStartByMe >= 0;

    return {
      wan,
      is_started_by_any_one_not_me: !!is_started_by_any_one_not_me,
      is_started_by_me,
      ip: is_started_by_me ? wan_selected[indexStartByMe].ip : "",
    };
  });

  // Mặc định chọn gói mình đang dùng, nếu chưa có thì gói đầu tiên còn trống
  const [selected, setSelected] = useState(
    (wans.find((w) => w.is_started_by_me) || wans.find((w) => !w.is_started_by_any_one_not_me))?.wan || ""
  );
  const current = wans.find((w) => w.wan === selected);
  // Giá Start ở phần cuối chuỗi, ví dụ "WAN51 - VIETTEL (sử dụng 24h) - 10000 VNĐ". Đổi IP khi đang dùng thì API không trừ tiền.
  const price = current ? wanPriceText(parseWan(current.wan).price) : "";

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="flex w-[min(560px,calc(100vw-32px))] flex-col text-fg">
        <div className="flex items-start gap-3 border-b border-line px-[18px] pb-3 pt-4">
          <h2 className="flex flex-1 flex-col gap-0.5 text-[17px] font-bold">
            Đổi IP
            {image?.name && <small className="text-[12.5px] font-medium text-muted">{image.name}</small>}
          </h2>
          <button
            type="button"
            aria-label="Đóng"
            className="grid h-8 w-8 flex-none place-items-center rounded-lg border border-line bg-surface text-fg hover:bg-surface-2"
            onClick={() => portalDialogRef.close()}
          >
            <IcX className="h-4 w-4" />
          </button>
        </div>

        <div className="flex flex-col gap-3 px-[18px] pb-[18px] pt-4">
          {!wans.length ? (
            <p className="m-0 rounded-xl bg-surface-2 px-4 py-3 text-muted">Máy này chưa có gói IP xoay.</p>
          ) : (
            <>
              <label className="flex flex-col gap-1 text-[12.5px] font-semibold text-muted">
                Gói IP xoay
                <select
                  className="pcr-select h-10 w-full appearance-none rounded-[10px] border border-line bg-surface pl-3 pr-8 text-sm font-medium text-fg"
                  value={selected}
                  onChange={(e) => setSelected(e.target.value)}
                >
                  {wans.map((w) => (
                    // Gói người khác đang dùng thì không chọn được, như bản cũ không có nút
                    <option key={w.wan} value={w.wan} disabled={w.is_started_by_any_one_not_me}>
                      {w.wan.trim()}
                      {w.is_started_by_me ? " (đang dùng)" : w.is_started_by_any_one_not_me ? " (đã có người dùng)" : ""}
                    </option>
                  ))}
                </select>
              </label>

              <div className="flex items-center gap-2 rounded-[10px] bg-surface-2 p-3 text-[13px]">
                <span className="flex-none text-muted">IP hiện tại</span>
                {current?.ip ? (
                  <>
                    <b className="font-mono">{current.ip}</b>
                    <CopyButton value={current.ip} label="Sao chép IP" />
                  </>
                ) : (
                  <b className="font-medium text-faint">Chưa có, bấm Start để lấy IP mới</b>
                )}
              </div>

              {current && !current.is_started_by_any_one_not_me && (
                <button
                  type="button"
                  className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-[11px] bg-brand text-[15px] font-semibold text-brand-ink hover:bg-brand-hover"
                  onClick={() =>
                    current.is_started_by_me ? handleClickChangeIP(current.wan) : handleClickStart(current.wan)
                  }
                >
                  <IcRefresh className="h-[18px] w-[18px]" />
                  {current.is_started_by_me ? "Đổi IP khác" : `Start${price ? ` · ${price}` : ""}`}
                </button>
              )}
              {current?.is_started_by_me && (
                <p className="m-0 text-center text-xs text-faint">Đổi IP không mất phí, mỗi lần cách nhau ít nhất 2 phút.</p>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default IPXoayModal;
